import { createFileRoute } from '@tanstack/react-router'
import {operators} from '@/constants/operators'
import OperatorsIcon from '@/components/OperatorIcons'
import {filterApi} from '@/queries/search'
import {Button} from '@/components/ui/button'
import {Card, CardContent, CardHeader, CardTitle} from '@/components/ui/card'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {type ColumnDef} from '@tanstack/react-table'
import {FileText} from 'lucide-react'
import {useEffect, useState} from 'react'
import {useMutation} from '@tanstack/react-query'
import { toast } from 'sonner'
import * as XLSX from 'xlsx';
import { ProductTypes } from '@/types'
import type { OperatorsName } from '@/stores/operator-store'
import { DataTable } from '@/components/ui/data-table'






interface ProductWithCategory {
  id: number
  name: string
  price: number | bigint,
  sim_card_type: 'credit' | 'permanent',
  period: number,
  second_price: number,
  capacity:string,
  product_type: keyof typeof ProductTypes
  categories: Array<{
    name: string,
    address: string,
    data: Array<{
      id: number,
      text:string,
    }>,
  }>
}

const generateExcelFile = (data: object[], fileName: string = 'file.xlsx'): void => {
  try {
      // Create a worksheet from the data
      const worksheet = XLSX.utils.json_to_sheet(data);

      // Create a new workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      // Write the workbook and trigger a download
      XLSX.writeFile(workbook, fileName);
  } catch (error) {
      console.log(error)
      toast.error('Error generating Excel file:');
  }
};

const ClientProducts = () => {
  const [operator, setOperator] = useState<OperatorsName>('irancell')
  const [products, setProducts] = useState<Array<ProductWithCategory>>([])
  const clientProductQuery = useMutation({
    mutationFn: (operator: string) => filterApi('product', {pagination: 'false', operator, 'categories': 'categories'}),
    mutationKey: ['getProductsQuery', operator],
    onSuccess(data) {
      setProducts(data.data.data.filter((pr:any) => {
        console.log(pr)
        return pr.product_type !== 'card_charge'}).map((d: ProductWithCategory) => {
        d.categories = d.categories.map(category => {
          if (typeof category.data === "string") {
            category.data = JSON.parse(category.data)
          }

          return category
        })

        return d
      }))
    },
  })

  useEffect(()=> {
    clientProductQuery.mutate(operator)
  }, [])

  const exportExcel = () => {
    const data = products.map(p => {
      return {
        id: p.id,
        name: p.name,
        period: p.period,
        price: p.price,
        second_price: p.second_price,
        category: p.categories?.[0]?.data.find((o) => o.id === Number(p.categories?.[0]?.address))?.text,
        sim_card_type: p.product_type !== 'td_lte_internet' && p.sim_card_type,
        capacity: p.capacity
      }
    })

    generateExcelFile(data, `${operator}.xlsx`)
  }

  const columns: ColumnDef<ProductWithCategory>[] = [
    {
      header: 'id',
      accessorKey: 'id',
    },
    {
      header: 'نام',
      accessorKey: 'name',
      enableSorting: true,
    },
    {
      header: 'نوع سیم کارت',
      accessorKey: 'sim_card_type',
      cell({row: {original: {sim_card_type, product_type}}}) {
        return product_type !== 'td_lte_internet' &&  sim_card_type ? sim_card_type === 'credit' ? 'اعتباری' : 'دائمی' : '-'
      },
    },
    {
      header: 'نوع محصول',
      accessorKey: 'product_type',
      cell({row}) {
        return ProductTypes[row.original.product_type]
      }
    },
    {
      header: 'دسته بندی',
      accessorKey: 'categories',
      cell({row}) {
        
        const data:Array<any> = row.original.categories?.[0]?.data
        const address = row.original.categories?.[0]?.address

        if (data === undefined) {
          return "-"
        }

        

        return <>
          {data?.find((d:any) => d.id === Number(address))?.text}
        </>
      },
    },
    {
      header: 'دوره',
      accessorKey: 'period'
    },
    {
      header: 'حجم',
      accessorKey: 'capacity',
    },
    {
      header: 'مبلغ',
      accessorKey: 'price',
      cell({row}) {
        return <>{Intl.NumberFormat('fa-ir').format(row.original.price)}</>
      },
    },
    {
      header: 'مبلغ دوم',
      accessorKey: 'second_price',
      cell({row}) {
        return row.original.second_price ? <>{Intl.NumberFormat('fa-ir').format(row.original.second_price)}</> : '-'
      },
    },
  ]

  return (
    <>
      <Card>
        <div className='flex justify-between items-center pl-4'>
          <CardHeader>
            <CardTitle>محصولات</CardTitle>
          </CardHeader>

          <Button onClick={exportExcel}>
            خروجی اکسل
            <FileText />
          </Button>
        </div>

        <CardContent>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <div className='flex items-center gap-2'>
                برای نمایش محصولات هر اپراتور از منوی رو به رو انتخاب کنید:
                <Button variant='outline'>
                  <OperatorsIcon operator={operator} />
                  <p className='mx-2'>
                    {operators.find((o) => o.name.toLowerCase() === operator.toLowerCase())?.title}
                  </p>
                </Button>
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent className='w-56'>
              <DropdownMenuLabel>اپراتور ها</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuRadioGroup
                value={operator}
                onValueChange={(value: any) =>{ setOperator(value)
                  clientProductQuery.mutate(value)
                }}
              >
                {(['irancell', 'aptel', 'shatel', 'rightel', 'mci'] as OperatorsName[]).map(
                  (operator: OperatorsName) => (
                    <DropdownMenuRadioItem value={operator}>
                      <OperatorsIcon operator={operator} />
                      <div className='mx-2'>
                        {operators.find((o) => o.name.toLowerCase() === operator.toLowerCase())?.title}
                      </div>
                    </DropdownMenuRadioItem>
                  )
                )}
              </DropdownMenuRadioGroup>
            </DropdownMenuContent>
          </DropdownMenu>

          <DataTable
            data={products}
            isLoading={clientProductQuery.isPending}
            columns={columns}
            pageCount={1}
            enablePagination={false}

          />
        </CardContent>
      </Card>
    </>
  )
}

export const Route = createFileRoute('/client/products/')({
  component: ClientProducts,
})
